import React from 'react';
import { Field, Modal } from '../../components/ui';

// Add/Edit reminder modal — mobile (full-screen, single column) variant.
export default function ReminderFormMobile({ vm }) {
  const { editing, form, setF, closeModal, saveReminder } = vm;
  return (
    <Modal
      fullScreen
      title={editing ? 'Edit Reminder' : 'Add Reminder'}
      onClose={closeModal}
      footer={<>
        <button className="btn light" onClick={closeModal}>Cancel</button>
        <button className="btn primary" onClick={saveReminder}>Save</button>
      </>}
    >
      <div className="form-grid" style={{ gridTemplateColumns: '1fr' }}>
        <div style={{ gridColumn: '1 / -1' }}>
          <Field label="Title" value={form.Title} onChange={v => setF('Title', v)} />
        </div>
        <Field label="From date" type="date" value={form.StartDate} required onChange={v => setF('StartDate', v)} />
        <Field label="Reminder time" type="time" value={form.ReminderTime} required onChange={v => setF('ReminderTime', v)} />
        <Field label="Status" type="select" value={String(form.Active)} options={[
          { value: '1', label: 'Active' },
          { value: '0', label: 'Paused' },
        ]} onChange={v => setF('Active', Number(v))} />
        <div style={{ gridColumn: '1 / -1' }}>
          <Field label="Notes" type="textarea" value={form.Notes} onChange={v => setF('Notes', v)} />
        </div>
      </div>
    </Modal>
  );
}
